import type { Product } from '~/modules/catalog/product/types';
import { NuxtI18nInstance } from 'nuxt-i18n';

export type ProductAvailableTypes = 'IN_STOCK' | 'OUT_OF_STOCK';

export interface ProductAvailable {
  status: boolean;
  label: string;
  stock_status: ProductAvailableTypes;
  icon: string;
  color: string;
}

export const availableList = (stock_status: ProductAvailableTypes): ProductAvailable => {
  switch (stock_status) {
    case 'IN_STOCK':
      return {
        status: true,
        stock_status: 'IN_STOCK',
        icon: '/icons/check.svg',
        label: 'product available',
        color: '#D12727',
      };
    default:
      return {
        status: false,
        stock_status: 'OUT_OF_STOCK',
        icon: '/icons/cross-circle-tile.svg',
        label: 'temporarily unavailable',
        color: '#707070',
      };
  }
};

export const isProductInStock = (product: Product): boolean => {
  if (!product || product.stock_status !== 'IN_STOCK') {
    return false;
  }
  return true;
};

export function getValueFromTable(days: string | number | null, i18n: NuxtI18nInstance): string {
  const daysNumber = typeof days === 'string' ? Number.parseInt(days, 10) : days;
  if (daysNumber === null || Number.isNaN(daysNumber)) {
    return '';
  }

  let category: number | string = '';
  if (daysNumber === 1) {
    category = i18n.t('Delivery 24h') as string;
  } else if (daysNumber > 1 && daysNumber <= 3) {
    category = i18n.t('Delivery 72h') as string;
  } else if (daysNumber > 3 && daysNumber <= 5) {
    category = i18n.t('Delivery 5d') as string;
  } else if (daysNumber > 5 && daysNumber <= 14) {
    category = i18n.t('Delivery 14d') as string;
  } else if (daysNumber > 14 && daysNumber <= 30) {
    category = i18n.t('Delivery 30d') as string;
  } else if (daysNumber > 30 && daysNumber <= 90) {
    category = i18n.t('Delivery 90d') as string;
  }

  return category;
}
